/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import moment from "moment/moment";
import React from "react";
import tableStyle from "../../theme/styles/table";
// import { getOSCollective } from "../../utils";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style } from "./styles";

function GohonzonOmamoriHandover({ member, onHandoverApplication }) {
  const { memberDetails } = member;

  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.memberId}
      </TableCell>
      <TableCell style={{ ...style.Cell, maxWidth: "150px" }}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {member.areaName || "-"}/ {member.clusterName || "-"}/{" "}
        {member.zoneName || "-"}/ {member.regionName || "-"}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <TableCell style={style.tableCell}>
          {member.allottedByName || "-"} <br />
          on:{" "}
          {/* {member.allotedAt !== null
            ? moment(member.allotedAt).format("L")
            : "-"} */}
          {member.allotedAt
            ? moment(member.allotedAt).format("DD/MM/YYYY")
            : "-"}
        </TableCell>
      </TableCell>
      <TableCell>
        <Box style={style.flexC}>
          <Button
            label="HANDOVER"
            variant="outlined"
            onClick={() => onHandoverApplication(member)}
            style={{ ...style.actionBtn }}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonOmamoriHandover;
